/**
 * DharmaResultCard.jsx — 密法修行建议卡片
 * Phase 99 · 显示 routed_module === "dharma" 时的结果
 *
 * 显示:
 *  - 本尊推荐
 *  - 五根柱子 (已应用层级)
 *  - 灌顶状态徽章
 *  - 铁律安全提示
 */

import React from "react";

const GD  = "#D4AF37";
const GR  = "#064E3B";
const GDH = "#B8960C";

const PILLAR_ICON = {
  "出离心": "🌱",
  "菩提心": "☸️",
  "空性见": "🔮",
  "清净观": "🏔️",
  "觉知":   "✨",
};

export default function DharmaResultCard({ guidance }) {
  if (!guidance || !guidance.deity_recommendation) return null;

  const {
    deity_recommendation,
    five_pillars_applied = [],
    credential_ok,
    lineage_match,
    safety_note,
    forbidden,
  } = guidance;

  return (
    <div style={{ marginTop: 14 }}>
      {/* 本尊推荐 */}
      {!forbidden && (
        <div style={{
          padding: "12px 14px",
          background: "rgba(212,175,55,.07)",
          border: `1px solid rgba(212,175,55,.25)`,
          borderRadius: 10,
          marginBottom: 10,
        }}>
          <div style={{ fontSize: 12, color: GDH, fontWeight: 700, marginBottom: 4, letterSpacing: 0.5 }}>
            🙏 参考本尊 / 法门
          </div>
          <div style={{ fontSize: 15, color: GR, fontWeight: 600 }}>
            {deity_recommendation}
          </div>
        </div>
      )}

      {/* 五根柱子 */}
      {five_pillars_applied.length > 0 && (
        <div style={{ marginBottom: 10 }}>
          <div style={{ fontSize: 12, color: "#64748B", fontWeight: 600, marginBottom: 6 }}>
            五根柱子 (已应用)
          </div>
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            {five_pillars_applied.map(name => (
              <span key={name} style={{
                fontSize: 12, padding: "3px 9px",
                background: "rgba(6,78,59,.07)", color: GR,
                borderRadius: 5, fontWeight: 500,
              }}>
                {PILLAR_ICON[name] || "·"} {name}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* 灌顶状态 */}
      {credential_ok === false && (
        <div style={{
          padding: "8px 12px",
          background: "#FFF7ED",
          border: "1px solid #FED7AA",
          borderRadius: 8,
          marginBottom: 10,
          fontSize: 13,
          color: "#92400E",
        }}>
          ⚠️ 此法门需要灌顶传承，请向具格上师求法后方可修持。
        </div>
      )}

      {/* 铁律 */}
      {safety_note && (
        <div style={{
          padding: "10px 12px",
          background: "#F8FAFC",
          borderLeft: `3px solid ${GD}`,
          borderRadius: "0 8px 8px 0",
          fontSize: 12,
          color: "#475569",
          lineHeight: 1.6,
        }}>
          {safety_note}
        </div>
      )}
    </div>
  );
}
